import { useEffect, useState } from "react";
import { Reveal } from "@/components/common/Reveal";
import api from "@/lib/api";

export function Stats() {
  const [stats, setStats] = useState({});
  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data || {})).catch(() => {});
  }, []);

  const val = (v) => (v && String(v).trim() ? v : "—");

  const items = [
    { label: "Entreprises", value: val(stats.entreprises), note: "du groupe" },
    { label: "Collaborateurs", value: val(stats.collaborateurs), note: "réunis" },
    { label: "Implantations", value: val(stats.implantations), note: "territoriales" },
    { label: "Pays", value: stats.pays || "2", note: "France & Suisse", real: true },
  ];

  return (
    <section className="relative py-24 border-y border-white/10 bg-[#0B0D13]" data-testid="stats">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4 gap-10">
        {items.map((it, i) => (
          <Reveal key={it.label} delay={i * 0.08}>
            <div className="text-center lg:text-left">
              <div className={`font-serif text-5xl sm:text-6xl ${it.real ? "text-gold" : "text-white"}`} data-testid={`stat-${it.label}`}>
                {it.value}
              </div>
              <div className="mt-3 eyebrow !text-slate-400">{it.label}</div>
              <div className="text-xs text-slate-500 mt-1">{it.note}</div>
            </div>
          </Reveal>
        ))}
      </div>
      <p className="mx-auto max-w-[1400px] px-5 sm:px-8 mt-10 text-xs text-slate-500">
        Seules les données réelles sont affichées. Les indicateurs chiffrés seront renseignés au fil du développement du groupe.
      </p>
    </section>
  );
}
